import { atom } from "recoil";
export const SettingsState = atom({
	key: "settingsState",
	default: {
		useHttps: false,
		serverAddress: "",
	},
});
